var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubadmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_60694",
    "data-name": "Group 60694",
    transform: "translate(-111 -11298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_9bbd57f4257a94f933063e8948ea1b19",
    "data-name": "9bbd57f4257a94f933063e8948ea1b19",
    transform: "translate(110.171 11297.172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60693",
    "data-name": "Group 60693",
    transform: "translate(2.001 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24322",
    "data-name": "Path 24322",
    d: "M23.657,18.242a3.968,3.968,0,0,0-7.792-1.058c-.126-.011-.256-.018-.383-.022l-1.209-.906V14.741a4.343,4.343,0,0,0,2.869-3.718h.379A1.086,1.086,0,0,0,18.6,9.94V9.219a1.08,1.08,0,0,0-.946-1.068l.419-.419A1.8,1.8,0,0,0,18.6,6.454V5.97A3.973,3.973,0,0,0,14.633,2H11.024a3.973,3.973,0,0,0-3.97,3.97v.484a1.8,1.8,0,0,0,.527,1.278L8,8.15a1.08,1.08,0,0,0-.946,1.068V9.94a1.086,1.086,0,0,0,1.083,1.083h.379a4.343,4.343,0,0,0,2.869,3.718v1.516l-1.213.91a5.334,5.334,0,0,0-.592.04v-1.13h.361a.356.356,0,0,0,.332-.224.362.362,0,0,0-.076-.393l-1.8-1.8a.364.364,0,0,0-.513,0L6.151,15.387,4.423,13.654a.364.364,0,0,0-.513,0l-1.8,1.8a.362.362,0,0,0-.076.393.356.356,0,0,0,.332.224h.361v5.775a.362.362,0,0,0,.361.361h1.18a6.425,6.425,0,0,0-.1,1.083.362.362,0,0,0,.361.361h16.6a.362.362,0,0,0,.361-.361,6.137,6.137,0,0,0-.173-1.437,3.979,3.979,0,0,0,2.34-3.611ZM17.882,9.219V9.94a.362.362,0,0,1-.361.361H17.16V8.858h.361a.362.362,0,0,1,.361.361ZM8.5,10.3H8.137a.362.362,0,0,1-.361-.361v-.72a.362.362,0,0,1,.361-.361H8.5Zm0-3.609v.935l-.4-.408a1.082,1.082,0,0,1-.318-.765V5.97A3.253,3.253,0,0,1,11.03,2.722h3.609A3.253,3.253,0,0,1,17.882,5.97v.484a1.082,1.082,0,0,1-.318.765l-.4.408V6.692a.363.363,0,0,0-.267-.35L11.479,4.9a.381.381,0,0,0-.274.036L8.678,6.378a.362.362,0,0,0-.178.314Zm.722,3.97V6.9l2.216-1.267,5,1.335V10.66a3.609,3.609,0,0,1-7.219,0Zm2.743,6.064a.366.366,0,0,0,.144-.289V14.929a4.043,4.043,0,0,0,1.444,0v1.509a.366.366,0,0,0,.144.289l1,.754-1.87,1.068-1.87-1.068ZM8.137,14.42l.956.956a.365.365,0,0,0-.235.339V21.49H7.415V15.715a.365.365,0,0,0-.235-.339ZM5.61,16.076h.361a.349.349,0,0,0,.18-.051.349.349,0,0,0,.18.051h.361v2.263a5.716,5.716,0,0,0-.733.617c-.123.123-.238.253-.35.386ZM4.888,21.49H3.444V15.715a.365.365,0,0,0-.235-.339l.956-.956.956.956a.365.365,0,0,0-.235.339ZM4.9,22.934a6.1,6.1,0,0,1,.1-.722h.245a.362.362,0,0,0,.361-.361V20.6a5.361,5.361,0,0,1,.863-1.13,2.921,2.921,0,0,1,.22-.2v2.588a.362.362,0,0,0,.361.361H9.219a.362.362,0,0,0,.361-.361V17.935a5.266,5.266,0,0,1,.628-.054l2.44,1.4a.37.37,0,0,0,.361,0l2.44-1.4c.1,0,.191.014.285.022-.011.112-.018.224-.018.339A3.959,3.959,0,0,0,20.625,22.1a5.4,5.4,0,0,1,.134.837ZM19.686,21.49a3.248,3.248,0,1,1,3.248-3.248,3.248,3.248,0,0,1-3.248,3.248Z",
    transform: "translate(-2.001 -2)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24323",
    "data-name": "Path 24323",
    d: "M49.444,40h-.722v.722a.723.723,0,0,0-.722.722v.722a.723.723,0,0,0,.722.722h.722v.722H48v.722h.722v.722h.722v-.722a.723.723,0,0,0,.722-.722v-.722a.723.723,0,0,0-.722-.722h-.722v-.722h1.444v-.722h-.722Z",
    transform: "translate(-31.398 -26.285)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.25
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1310",
    "data-name": "Rectangle 1310",
    width: 24,
    height: 24,
    transform: "translate(111 11298)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubadmin);
export default __webpack_public_path__ + "static/media/subadmin.757a2fe13b330da7316837f97541b13a.svg";
export { ForwardRef as ReactComponent };